export const USERS_SLICE_KEY = 'users';
export const USER_TYPE = 'User';
export const USERS_BASE_PATH = 'management/users';
export const USERS_API_PATH = 'management';

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}
